import { HEADER_HEIGHT } from '@/ui/Layout/Header/HeaderBar';
import Image from 'next/image';

export default function GOGovLogo({ ignoreMargin = false }) {
  return (
    <Image
      width={210}
      height={HEADER_HEIGHT - 16}
      src='/assets/Go.Gov-TM-Logo.png'
      alt='Go.Gov Logo'
      style={{
        objectFit: 'contain',
        objectPosition: 'left',
        margin: ignoreMargin ? 0 : '8px',
        marginLeft: ignoreMargin ? 0 : 14,
      }}
      priority
    />
  );
}
